import { ChartTimeSeriesLineTheme } from '@hcs/design-system';
import { DateStr } from '@hcs/types';

import { CerberusStatsRpiChart } from '../../components';
import { MACRO_INSIGHTS_FROM_DATE } from '../../constants';
import { useMsaRpiTimeSeries } from '../../hooks';
import { mapPropertyTypeToPropertyTypeEnum } from '../../utils';

const dataHcName = 'msa-rpi-chart';

interface MsaHpiChartProps {
  className?: string;
  msaId: string;
  propertyType: 'singleFamily' | 'condo';
  fromDate?: DateStr;
  toDate?: DateStr;
  theme?: Partial<ChartTimeSeriesLineTheme>;
}
export const MsaRpiChart = ({
  msaId,
  className,
  propertyType,
  fromDate = MACRO_INSIGHTS_FROM_DATE,
  toDate,
  theme,
}: MsaHpiChartProps) => {
  const propertyTypeEnum = mapPropertyTypeToPropertyTypeEnum(propertyType);
  const { data, isLoading } = useMsaRpiTimeSeries({
    msaId,
    fromDate,
    toDate,
    propertyType: propertyTypeEnum,
  });
  return (
    <CerberusStatsRpiChart
      dataHcName={dataHcName}
      className={className}
      data={data}
      theme={theme}
      isLoading={isLoading}
    />
  );
};
